import React from "react";
import { CheckCircle2 } from "lucide-react";
import { StatusBadge } from "@/components/ui/status-badge";
import { DataDocs } from "../../types/tables-data";

export const NewBadge = () => <StatusBadge tone="success">New</StatusBadge>;

type DocumentRowNewBadgeProps = {
  document: DataDocs | undefined;
};

export const DocumentRowNewBadge: React.FC<DocumentRowNewBadgeProps> = ({
  document
}) => {
  const isDocumentNew =
    document?.isNew && document.super_class !== "Processing";

  return isDocumentNew ? <NewBadge /> : null;
};

type DocumentRowStatusProps = {
  document: DataDocs | undefined;
};

export const DocumentRowStatus: React.FC<DocumentRowStatusProps> = ({
  document
}) => {
  const documentHasSummary = !!document?.summary;
  const isNew = document?.isNew && document.super_class !== "Processing";

  if (document?.last_updated_at) return null;

  if (!isNew) return null;

  if (documentHasSummary) {
    return <CheckCircle2 className="mr-3 size-3.5 text-success" />;
  }

  return <span className="mr-3 text-xs text-fg-3">Generating</span>;
};
